export default {
  idTab: {
    type: 'string',
    default: 'pme',
  },
};
